import { makeStyles } from '@material-ui/core'

import theme from 'theme'

export default makeStyles(() => ({
  card: {
    borderRadius: 16,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${theme.palette.divider}`,
    padding: 150,
    maxWidth: '100vw',
    maxHeight: '100vh',
    margin: 'auto',
  },
  cardContent: {
    width: '100%',
    padding: 0,
  },
  title: {
    fontFamily: 'Raleway, sans-serif',
    fontWeight: 500,
    marginBottom: 24,
    maxWidth: '100vw',
    margin: '0 auto',
  },
  image: {
    width: 100,
    height: 100,
    maxWidth: 200,
    maxHeight: 200,
  },
}))
